var map = {
	"./blocks-bar.svg": "7494",
	"./blocks-shuffle.svg": "1701",
	"./bullets-shuffle.svg": "bf40",
	"./circles.svg": "448d",
	"./clock.svg": "127c",
	"./dots-bar.svg": "32fc",
	"./grid-bullets.svg": "09ca",
	"./line-bar.svg": "1898",
	"./ring-infinity.svg": "4e3d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c6e";